/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class VulnerabilityBySeverityAndKevWidgetConfiguration extends models.BaseChartWidgetConfigurationModel {
    constructor() {
        super();
        this.setDiscriminator("VulnerabilityBySeverityAndKevWidgetConfiguration");
    }

    getFixupPrototypeFunction() { return VulnerabilityBySeverityAndKevWidgetConfiguration.fixupPrototype; }

    static newInstance(model: Partial<VulnerabilityBySeverityAndKevWidgetConfiguration>): VulnerabilityBySeverityAndKevWidgetConfiguration {
        let obj = Object.assign(new VulnerabilityBySeverityAndKevWidgetConfiguration(), model);
        VulnerabilityBySeverityAndKevWidgetConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<VulnerabilityBySeverityAndKevWidgetConfiguration>): VulnerabilityBySeverityAndKevWidgetConfiguration {
        if (!model) return null;
        return VulnerabilityBySeverityAndKevWidgetConfiguration.newInstance(<VulnerabilityBySeverityAndKevWidgetConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: VulnerabilityBySeverityAndKevWidgetConfiguration) {
        if (!obj) return;

        models.VulnerabilityBySeverityAndKevWidgetConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: VulnerabilityBySeverityAndKevWidgetConfiguration): boolean {
        if (models.BaseChartWidgetConfigurationModel.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, VulnerabilityBySeverityAndKevWidgetConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
